import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ConversationSearchResultDTO  {
    _originalTypeClassName = "ekylikeio.BO.ConversationSearchResultDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ConversationSearchResultDTO.translate = translateService;
}
this.ConversationId = null;
this.Subject = null;
this.Date = null;
this.Body = null;
this.To = null;
this.CC = null;
this.ConversationSearchResultDTOKey = null;
this._key = this.ConversationSearchResultDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
ConversationId:any;
Subject:any;
Date:any;
Body:any;
To:any;
CC:any;
private _ConversationSearchResultDTOKey:any;
get ConversationSearchResultDTOKey(): any {
    return this._ConversationSearchResultDTOKey;
  }
set ConversationSearchResultDTOKey(value: any) {
    this._ConversationSearchResultDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ConversationSearchResultDTOKey == null || $this.ConversationSearchResultDTOKey == 0;
            }


}